import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';
import map from 'lodash/map';
import InnerHTML from '@Components/InnerHTML';
import { METABOLIZATION_GROUPS_HEADERS } from '@Constants/ElementConstants';
import ShowMoreComponent from '@Components/Results/utils/show-more.component';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service';
import StickyTableHeaderComponent from '@Components/Results/sticky-table-header.component';
import TableColumnsSwitcherComponent from '@Components/Results/reactions/reaction-details/table-columns-switcher/table-columns-switcher.component';

function ReactionMetabolizationGroups({ detail, uniqueId, containerRef }) {
  const defaultLimit = 7;

  const generateFormatedData = () => {
    const formatedData = {
      headers: METABOLIZATION_GROUPS_HEADERS,
      rows: map(detail.metabolizationGroups, (group, i) => ({
        id: i,
        cells: map(METABOLIZATION_GROUPS_HEADERS, (header) => ({
          id: header.id,
          order: header.order,
          value: group[header.id],
        })),
      })),
    };

    formatedData.rows.forEach((row) => {
      row.cells.forEach((cell) => {
        if (!isUndefined(cell.value) && cell.value.length) {
          const headerItem = find(formatedData.headers, { id: cell.id });
          headerItem.hasContent = true;
        }
      });
    });

    return formatedData;
  };

  const [formatedData, setFormatedData] = useState(generateFormatedData());
  const [currentLength, setCurrentLength] = useState(defaultLimit);
  const columnSwitcherRef = useRef(null);

  const updateHeaders = (headers) => {
    setFormatedData((prevData) => ({ ...prevData, headers }));
  };

  const showAllNonEmptyCols = () => {
    columnSwitcherRef.current.showAllNonEmptyCols();
  };

  const showAll = () =>
    new Promise((resolve) => {
      setCurrentLength(formatedData.rows.length);
      resolve();
    });

  const showLess = () => {
    setCurrentLength(defaultLimit);
  };

  return (
    <div className="additional-data-tables">
      <div className="switcher-wrapper">
        <TableColumnsSwitcherComponent
          headers={formatedData.headers}
          uniqueId={uniqueId}
          containerRef={containerRef}
          ref={columnSwitcherRef}
          updateHeaders={updateHeaders}
        />
      </div>
      <div className="clearfix metabolization-groups-container">
        <style>{ReactTableColumnSwitcherHelper.generateCssRules(uniqueId, formatedData.headers)}</style>
        <table
          className={`rx-table rx-table--additional-info sticky-table-header ${ReactTableColumnSwitcherHelper.getTableClass(
            uniqueId,
            formatedData.headers
          )}`}>
          <StickyTableHeaderComponent headers={formatedData.headers} showAllNonEmptyCols={showAllNonEmptyCols} />
          <tbody>
            {formatedData.rows.slice(0, currentLength).map((row, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={index}>
                {formatedData.headers.map((cell, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <InnerHTML tag="td" key={i} className={`column-${cell.cssid}`} html={row.cells[i].value} mode="escape" />
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="rx-btn-group--center">
          <ShowMoreComponent
            initial={defaultLimit}
            current={currentLength}
            total={formatedData.rows.length}
            container=".metabolization-groups-container"
            moreHandler={showAll}
            lessHandler={showLess}
            threshold={formatedData.rows.length}
          />
        </div>
      </div>
    </div>
  );
}

ReactionMetabolizationGroups.propTypes = {
  detail: PropTypes.object.isRequired,
  uniqueId: PropTypes.string.isRequired,
  containerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
};

export default ReactionMetabolizationGroups;
